<template>
    <header
        :class="[$style.header, isSearchOpened && $style.search_opened]"
        data-interface-section="desktop-header"
    >
        <Link
            :to="{ name: ROUTE_NAMES.MAIN }"
            data-interface-target="navigation-link"
            :class="$style.icon_wrapper"
            hoverAnimation="rainbow"
        >
            <Logo
                mode="default"
                :class="$style.logo_override"
            />
        </Link>
        <div :class="$style.flexible_block">
            <Search
                @open="isSearchOpened = true"
                @close="isSearchOpened = false"
            />
            <template v-if="userInfoLoaded">
                <DesktopNoAdButton />
                <NoAdActiveBadge />
                <YoutubeButton />
                <UserWidget
                    v-if="user"
                    :user
                />
                <Button
                    v-else
                    size="l"
                    color="salad"
                    interfaceTarget="open-sign-in-modal"
                    :class="$style.sign_in_button_override"
                    :label="$tr('header.login')"
                    @click="signin"
                />
            </template>
            <HeaderTiles :class="$style.header_tiles_override" />
        </div>
    </header>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { ref } from 'vue'

import Button from '@/components_new/Buttons/Button.vue'
import NoAdActiveBadge from '@/components_new/Headers/components/NoAdActiveBadge.vue'
import YoutubeButton from '@/components_new/Headers/components/YoutubeButton.vue'
import Link from '@/components_new/Link.vue'
import Logo from '@/components_new/Logo.vue'
import { useUserInfoLoaded } from '@/composables/use-user-state'
import { ROUTE_NAMES } from '@/router/constants'
import { useLayoutStore } from '@/store/layout-store'
import { useUserStore } from '@/store/user-store/user-store'

import Search from '../Search/Search.vue'
import DesktopNoAdButton from './components/DesktopNoAdButton.vue'
import HeaderTiles from './components/HeaderTiles.vue'
import UserWidget from './components/UserWidget.vue'

const layoutStore = useLayoutStore()
const userStore = useUserStore()

const isSearchOpened = ref(false)
const { user } = storeToRefs(userStore)
const userInfoLoaded = useUserInfoLoaded()

function signin() {
    layoutStore.openSignInModal('desktop-header')
}
</script>
<style module>
.header {
    display: flex;
    align-items: center;
    height: 100%;
    gap: 4px;
}

.flexible_block {
    min-width: 0;
    display: flex;
    flex-grow: 1;
    align-items: center;
    gap: 4px;
}

.header_tiles_override {
    margin-left: auto;
}

.icon_wrapper {
    border-radius: 62px;
    background-color: var(--purple-400);
    padding: 0 20px;
    display: flex;
    align-items: center;
    height: 56px;
}

.icon_wrapper:hover,
.icon_wrapper:focus {
    filter: brightness(1.08);
}

.logo_override {
    height: 34px;
    width: 160px;
}

.sign_in_button_override {
    height: 56px;
}

.search_opened .tasks_widget_override,
.search_opened .header_tiles_override {
    display: none;
}

@media (--desktop-large-plus) {
    .search_opened .header_tiles_override {
        display: flex;
    }
}
</style>
